(function(){
     'use strict';

     angular
        .module('appback')
        .factory('TransportesService', TransportesService);

    TransportesService.$inject = ['$http'];

    function TransportesService($http){

        var service= {
           getTransportes:getTransportes,
           guardar:guardar,
           getCentroTransporte:getCentroTransporte,
           enviarTransporte:enviarTransporte,
           getNotesTransporte:getNotesTransporte,
           setNota: setNota,
           getNuevoEnvio:getNuevoEnvio,
           setIAPrediction:setIAPrediction
        };

        return service;

         function enviarTransporte(envio,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
               envio:angular.toJson(envio)
            });
            $http.post('/backend/transporte/enviartransporte', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }

        function setIAPrediction(peticion_id,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
                peticion_id:peticion_id
            });
            return $http.post('/backend/transporte/setiaprediction', data, config)
        }

 		
        function getCentroTransporte(centro_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/transporte/gettransportecentro', { params : { centro_id:centro_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        function getNotesTransporte(centro_id,peticion_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/transporte/getnotastransporte', { params : { centro_id:centro_id, peticion_id:peticion_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                console.log("data received from call", data)
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        function setNota(note, transporte_id, callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                note: note,
                transporte_id: transporte_id
            });

            $http.post('/backend/transporte/setnota', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }
        function getNuevoEnvio(timestamp, pais_id, callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;',
                    ignoreLoadingBar: true
                },
                ignoreLoadingBar: true
            }

            $http.get('/backend/transporte/nuevoenvio', { ignoreLoadingBar:true,params : {timestamp:timestamp, pais_id:pais_id,ignoreLoadingBar: true}}, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }
        function getTransportes(callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/preciotransporte/gettransportes', { params : {  } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        function guardar(vm,callback){
        	var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
               transportes:angular.toJson(vm.transportes)
            });
            $http.post('/backend/preciotransporte/guardar', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }

      
    }
})();